/*eslint-disable */
var $ = window.jQuery = require('jquery'); 
import { bus } from '../../main';
import {
  mapGetters,
} from 'vuex';
export default {
  name: 'video-meeting-create',
  components: {},
  props: [],
  data () {
    return {
      userProfileDetails:{},
      userIdForRoomId:'',
      roomIdForChat:'',
      meetingUrlOrigin:'',
      meetingRoomDisabled:true
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
    ]),
    getUserDetailsInfo(){
      this.userProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
    setIntialUserIdFun(){
      if(this.userProfileDetails != undefined){
        this.userIdForRoomId = this.userProfileDetails.id
      }
    }
  },
  mounted () {
    this.getUserDetailsInfo
    this.setIntialUserIdFun
    this.meetingUrlOrigin = window.location.origin
    this.$store.dispatch('apiUserRoomCreateForChatFunction', {user:this.userIdForRoomId}).then((res)=>{
      this.roomIdForChat = res.data.data.id
    }).catch((err)=>{
    })
  },
  methods: {
    crrateLinkAgainFun(){
      this.meetingRoomDisabled = false
      this.$store.dispatch('apiUserRoomCreateForChatFunction', {user:this.userIdForRoomId
      }).then((res)=>{
      this.roomIdForChat = res.data.data.id
      this.meetingRoomDisabled = true
      }).catch((err)=>{
      })
    }
  },
  watch:{
    getUserDetailsInfo(){
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    setIntialUserIdFun(){
      if(this.userProfileDetails != undefined){
        this.userIdForRoomId = this.userProfileDetails.id
      }
    }
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    if(to.name != 'videoChat'){
    }
    next();
  },
}


